import type { FlatStringObject } from 'commonTypes';

export enum appConstants {
  phPrevSessionIdData = 'phPrevSessionIdData',
  phSkipLasUsedMethod = 'phSkipLasUsedMethod',
  transaction_status = 'transaction_status',
  language_key = 'airPmCashierLang',
}

export enum submitFormActions {
  blank = 'blank',
  redirect = 'redirect',
  result = 'result',
}

export enum pmAction {
  // WARNING! These paths are used in `index.html`
  // (gtm) so if you are about to update it, please update the html as well
  deposit = 'deposit',
  withdrawal = 'withdrawal',
  // /end of warning
  error = 'error',
  content = 'content',
  checkout = 'checkout',
  page3dsResult = '3ds_result',
  tokenizationPage = 'tokenization_page',
  accManagement = 'acc_management',
}

// NOTICE: maybe will be changed in the future to Widget
export const APP_NAME = 'cashier';

export enum PAGE_STATUS {
  success = 'success',
  error = 'error',
  processing = 'processing',
  await = 'await',
}

export const CLICKSTREAM_STATUSES_MAP = {
  error: 'decline',
  success: 'success',
  processing: 'processing',
  await: 'processing',
};

export const API_CASHIER_SERVICE = '/api/cashier-service';

export const NOTIFICATIONS_URL = '/notifications';
export const ANALYTICS_URL = '/cashier-service/analytics';

export const NATIVE_PAY_TYPES = {
  GOOGLE: 'GooglePay',
  APPLE: 'ApplePay',
};

export const LOGO_URL_INITIAL = '/cashier-logo.url/';
export const LOGO_URL_PATTERN = 'http://cashier-logo.url';

export const CASHIER_CONTENT_PAGE_URL = '/content/';
export const CASHIER_CONTENT_PAGE_URL_INITIAL = '/cashier-content-page.info/';
export const CONTENT_PAGE_URL_PATTERN = 'http://cashier-content-page.info';

export enum LINK_TARGET {
  SELF = '_self',
  BLANK = '_blank',
}

export enum LayoutType {
  mobile = 'mobile',
  desktop = 'desktop',
}

export const CLOSE_ICON = 'alwaysCloseIcon';

export const LOCAL_THEME = 'local_theme';

export enum FieldType {
  amount,
  checkbox,
  select,
  input,
  expirationDate,
  cardPan,
  cardCvv,
  card,
  userPhoneVisible,
  betShop,
  phone,
  date,
  file_upload,
  disabledInputCopy,
}

export const DEFAULT_THEME_NAME = 'brand11';

/**
 * Maps specific brand codes to their theme names.
 * Shared between themePreloader (pre-React) and getThemeByBrand (runtime).
 * For more info: https://confluence.pm.tech/pages/viewpage.action?spaceKey=PD&title=Design+Tokens
 */
export const THEME_BRAND_MAP: Record<string, string> = {
  NOMAD: 'brand6',
  GLS: 'brand1',
  FLEX: 'brand8',
  SCCOM: 'brand8',
};

const WIDGET_SERVICE_ENV = process.env.NODE_ENV === 'production' ? '/api/cashier-service/' : '/cash-ph20-service/';
export const WIDGET_API = `${WIDGET_SERVICE_ENV}v1.0`;

export const HEADER_ICON: FlatStringObject = {
  close: 'close',
  back: 'back_ios',
};

export const WIDGET_HEADER_HEIGHT = 56;
export const WIDGET_HEADER_TABS_HEIGHT = 45;
export const WIDGET_HEADER_CURRENCY_SELECT_HEIGHT = 56;

export const PLATFORM_MIN_HEIGHT = 650;
export const DESKTOP_MODAL_MIN_HEIGHT = 675;
export const DESKTOP_MODAL_WIDTH = 656;

export const WIDGET_HEIGHT_GAP = 50;
export const DEFAULT_WIDGET_APP_HEIGHT = 350;

export const INFINITY_SYMBOL = '∞';

export const DEFAULT_LOGO_SIZE = 40;

export const FLOW_DEFAULT = 'default';
export const FLOW_ROUTING = 'routing';
export const FLOW_ROUTING_REJECT = 'routing-reject';
export const FLOW_ROUTING_DEPOSIT = 'deposit';
export const FLOW_ROUTING_CHECKOUT = 'checkout';
export const FLOW_ROUTING_WITHDRAWAL = 'withdrawal';
